"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameSpaceKeyTON = exports.NameSpaceKeySOL = exports.NameSpaceKeyEip155 = void 0;
exports.NameSpaceKeyEip155 = "eip155";
exports.NameSpaceKeySOL = "sol";
exports.NameSpaceKeyTON = "ton";
